import { useTranslation } from 'react-i18next'
type ConversationType = 'borrow' | 'comment'

interface BookListSelectionToolbarProps {
    // Selection info
    selectedCount: number
    onDeselectAll: () => void

    // Context
    isSharedView: boolean
    isBiblioverso: boolean

    // Bulk actions (own library)
    onBulkEdit?: () => void
    onBulkFetchInfo?: () => void
    fetchingInfo?: boolean
    onBatchAddToList?: () => void
    onBulkDelete?: () => void
    pendingUpdatesCount?: number
    onSavePendingUpdates?: () => void

    // Conversation actions (shared/biblioverso)
    onOpenConversationRequest?: (type: ConversationType) => void
}

export default function BookListSelectionToolbar({
    // Selection info
    selectedCount,
    onDeselectAll,

    // Context
    isSharedView,
    isBiblioverso,

    // Bulk actions (own library)
    onBulkEdit,
    onBulkFetchInfo,
    fetchingInfo,
    onBatchAddToList,
    onBulkDelete,
    pendingUpdatesCount,
    onSavePendingUpdates,

    // Conversation actions (shared/biblioverso)
    onOpenConversationRequest,
}: Readonly<BookListSelectionToolbarProps>) {
    const { t } = useTranslation()

    return (
        <div className="selection-toolbar animate-fade-in-up">
            <div className="selection-info">
                <span className="selection-count-badge">{selectedCount}</span>
                <span className="selection-text">{t('bookList.selection.selected')}</span>
            </div>
            <div className="selection-actions">
                <button className="btn-secondary btn-sm" onClick={onDeselectAll}>
                    ✕ {t('bookList.selection.deselect')}
                </button>

                {!isBiblioverso && !isSharedView ? (
                    // My Library Actions
                    <>
                        <button
                            className="btn-secondary btn-sm fetch-info-btn"
                            onClick={onBulkFetchInfo}
                            disabled={fetchingInfo}
                            style={{ marginLeft: '0.5rem', background: '#f0fdf4', borderColor: '#4ade80', color: '#166534' }}
                        >
                            {fetchingInfo ? t('bookList.selection.fetching') : `🌐 ${t('bookList.selection.fetchInfo')}`}
                        </button>

                        <button
                            className="btn-secondary btn-sm"
                            onClick={onBatchAddToList}
                            style={{ marginLeft: '0.5rem', background: '#eef2ff', borderColor: '#818cf8', color: '#4338ca' }}
                        >
                            📑 {t('bookList.selection.addToList')}
                        </button>
                        <button className="btn-primary btn-sm" onClick={onBulkEdit} style={{ marginLeft: '0.5rem' }}>
                            ✏️ {t('bookList.selection.bulkEdit')}
                        </button>
                        {!!pendingUpdatesCount && pendingUpdatesCount > 0 && (
                            <button className="btn-success btn-sm save-pending-btn" onClick={onSavePendingUpdates} style={{ marginLeft: '0.5rem' }}>
                                💾 {t('bookList.selection.saveChanges', { count: pendingUpdatesCount })}
                            </button>
                        )}
                        <button className="btn-danger btn-sm" onClick={onBulkDelete} style={{ marginLeft: '0.5rem' }}>
                            🗑️ {t('bookList.selection.delete')}
                        </button>
                    </>
                ) : (
                    // Shared / Biblioverso Actions
                    <>
                        <button
                            className="btn-primary btn-sm"
                            onClick={() => onOpenConversationRequest?.('borrow')}
                            style={{ marginLeft: '0.5rem' }}
                        >
                            📖 {t('bookList.selection.borrow')}
                        </button>
                        <button
                            className="btn-secondary btn-sm"
                            onClick={() => onOpenConversationRequest?.('comment')}
                            style={{ marginLeft: '0.5rem' }}
                        >
                            💬 {t('bookList.selection.comment')}
                        </button>
                    </>
                )}
            </div>
        </div>
    )
}
